import './HorizontalNaturalCarousel.scss';
class HorizontalNaturalCarousel {
    constructor( node ) {
        this.node = node;
    }
    init() {
        let t = this;

        let images = t.node.querySelectorAll('.wrapper__element');
        let observer = new IntersectionObserver(
            ( entries, index ) => {
                entries.forEach( ( entry, index ) => {
                    if( entry.isIntersecting ) {
                        window.theme.lazyObj.loadSingleImage( entry.target.querySelector('.LazyAsset__item') );
                        observer.unobserve( entry.target );
                    }
                });
            },
            {
                threshold : 0,
                rootMargin: '100px 100px',
                root: t.node.querySelector('.HorizontalNaturalCarousel__wrapper'),
            }
        );
        images.forEach( ( image,index ) => {
            observer.observe( image );
        });
    }
}
JSModules['HorizontalNaturalCarousel'] = HorizontalNaturalCarousel;
export default HorizontalNaturalCarousel;